import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as d3 from 'd3';

const PI = Math.PI;

function deg2rad(deg:number) {
   return deg * Math.PI / 180
 }
  function perc2Deg(perc:number) {
    return perc * 360;
  };

  function perc2Rad(perc:number) {
    return deg2rad(perc2Deg(perc));
  };

@Component({
  selector: 'app-transport-gauge',
  templateUrl: './transport-gauge.component.html',
  styleUrls: ['./transport-gauge.component.scss'],
})
export class TransportGaugeComponent implements AfterViewInit {
  @ViewChild('gauge') gauge: ElementRef;
  @Input() set data(piles:any[]){
    this._piles = piles;
    this.prepareData();

  }
  @Input() road:string;
  private width:number=50;
  private height:number=50;
  private _piles:any[] = [];
  private svg:any;
  public percentage:number=0;
  constructor() { }
  ngAfterViewInit(): void {

    this.createSvg();
    this.drawChart();
  }



  createSvg(){
    const {width,height}=this;
    this.svg = d3.select(this.gauge.nativeElement).append("svg")
    .attr("width", this.width)
    .attr("height", this.height)
    .append("g")

    .attr("transform",
          `translate(${this.width/2},${this.height/2})`);
  }
  drawChart(){
    const oR = this.width / 2.2;
    const iR = 0.66*oR;
    const data = [{start:0,size:this.percentage}];
    const bgArc = d3.arc().startAngle(deg2rad(-140)).endAngle(deg2rad(140)).innerRadius(iR).outerRadius(oR);
    const valArc = d3.arc().startAngle( deg2rad(-140)).endAngle((d:any)=>{
      const v = d.size*280 - 140;
      return deg2rad(v)
    }).innerRadius(iR).outerRadius(oR);
    let g = this.svg.selectAll('g').data(data).enter().append('g').attr('class','arc');
    g.append('path').attr('d',bgArc).attr('fill','#999')
        g.append('path').attr('d',valArc).attr('fill','#333')

  }

  prepareData(){
    if(!this.road) return;
    if(!this._piles) return;
    const roadPiles = this._piles.filter( (p:any)=>{
      return p.road == this.road;
    });
    const roadpilesTransported = roadPiles.filter( (p:any)=>{
      return p.status == 'transported';
    })
    const percent =( roadpilesTransported.length)/roadPiles.length;
    this.percentage = percent;
  }

}
